const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryWarehouseShelfTree({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/tree", params);
      return data;
    }
  }
};

export default store;
